export default {
  absolute: 'Absoluto',
  accountError: 'Nagkaroon ng error sa pag-update ng account.',
  accountProfile: 'Profile ng Account',
  accountSecurity: 'Seguridad ng Account',
  accountSuccessBody: 'Na-update na ang iyong account.',
  accountSuccessHead: 'Tagumpay',
  accountTab: 'Account {tab}',
  actual: 'Aktwal',
  addNumber: 'Magdagdag ng Numero',
  addPhoneNumber: '+ Magdagdag ng numero ng telepono',
  amps: 'Amps',
  archived: 'Na-archive',
  atHome: 'Nasa Bahay',
  attachFile: 'Mag-attach ng File',
  authenticatePIN: 'I-authenticate ang PIN',
  auto: 'Awtomatiko',
  automaticSelfConsumption: 'Awtomatikong Sariling Konsumo',
  autoSchedule: 'Ang tampok na Auto Schedule ay natututo ng iyong mga gawi at bumubuo ng iskedyul batay dito – habang nakakatipid ng pera. I-on ito at gamitin ang iyong device gaya ng dati. Pagkatapos ng isang linggo, ang Auto Schedule ang gagawa ng lahat ng trabaho.',
  autoScheduleHead: 'Magtipid at Maging Berde gamit ang Auto Schedule',
  auxHeat: 'Aux Heat Lang',
  available: 'Magagamit',
  backup: 'Backup',
  backToDashboard: 'Bumalik sa Dashboard',
  baseline: 'Baseline',
  boost: 'Boost',
  byPower: 'Ayon sa Power',
  byPV: 'Ayon sa PV',
  cancel: 'Kanselahin',
  capacity: 'Kapasidad',
  chargeFromGridCurrent: 'Mag-charge mula sa Grid ayon sa Kasalukuyan',
  chargeFromGridPower: 'Mag-charge mula sa Grid ayon sa Power',
  chargeFromPV: 'Mag-charge mula sa PV',
  charging: 'Nagcha-charge',
  checkEmail: 'Suriin ang Iyong Email',
  checkPIN: 'Suriin ang iyong email para sa 5-digit na PIN upang mag-sign in.',
  cleanBackup: 'Malinis na Backup',
  close: 'Isara',
  cloudCoverage: 'Takip ng Ulap',
  codeError: 'Maling code. Pakisubukang muli.',
  codePlaceholder: 'Ilagay ang Verification Code',
  codePlaceHolder: 'Halimbawa: XXXXXXX',
  codeSent: 'Verification Code na ipinadala; pakisuri ang iyong telepono.',
  compLower: 'Comp at Lower',
  compressor: 'Compressor',
  confirm: 'Kumpirmahin',
  cool: 'Palamig',
  coolSetpoint: 'Setpoint ng Palamig',
  cooling: 'Pagpapalamig',
  coolingSetpoint: 'Setpoint ng Pagpapalamig',
  currentConditions: 'Kasalukuyan',
  currentlyRunning: 'Kasalukuyang Tumatakbo',
  curtailment: 'DR Curtailment',
  date: 'Petsa',
  datePickerDay: 'Araw',
  datePickerMonth: 'Buwan',
  datePickerWeek: 'Linggo',
  days: {
    monday: {
      long: 'Lunes',
      short: 'Lun',
      '1la': 'L',
    },
    tuesday: {
      long: 'Martes',
      short: 'Mar',
      '1la': 'M',
    },
    wednesday: {
      long: 'Miyerkules',
      short: 'Miy',
      '1la': 'M',
    },
    thursday: {
      long: 'Huwebes',
      short: 'Huw',
      '1la': 'H',
    },
    friday: {
      long: 'Biyernes',
      short: 'Biy',
      '1la': 'B',
    },
    saturday: {
      long: 'Sabado',
      short: 'Sab',
      '1la': 'S',
    },
    sunday: {
      long: 'Linggo',
      short: 'Lin',
      '1la': 'L',
    },
  },
  defaultDeviceScheduleOption: 'Walang Available na Mga Iskedyul',
  defaultMode: 'Default na Mode',
  defaultSetpoint: 'Default na Setpoint',
  deleteDevice: 'Tanggalin ang Device',
  deleteMessage: 'Tanggalin',
  deleteNumber: 'Tanggalin',
  deleteSchedule: 'TANGGALIN ANG SCHEDULE',
  desiredSiteMeter: 'Ninanais na Site Meter Reading',
  device: 'Device',
  deviceBattery: 'Baterya | {n} Baterya',
  deviceBatteryCapacity: 'Kapasidad',
  deviceBatteryConsumption: 'Sariling Konsumo',
  deviceBatteryPower: 'Power ng Baterya',
  deviceControl: 'Kontrol ng Device',
  deviceDefaultMode: 'Default na Mode',
  deviceDefaultSetpoint: 'Default na Setpoint',
  deviceEv: 'EV | {n} EV',
  deviceEvCharger: 'EV Charger | {n} EV Charger',
  deviceEVPower: 'Power ng Charge',
  deviceFan: 'Mode ng Fan',
  deviceGE: 'Pampainit ng Tubig o Window AC',
  deviceInstructions: 'Bigyan ang iyong device ng madaling pangalan tulad ng "Main Waterheater" o "Bedroom Air Conditioner."',
  deviceKind: 'Uri ng Device',
  deviceLimitNoAccess: 'Ang manufacturer ng device na ito ay maingat na pinoprotektahan ang impormasyon ng iyong termostat. Maaari mong tingnan o kontrolin ang iyong device nang manu-mano o mula sa inirerekomendang app ng manufacturer.',
  deviceLimitNoControl: 'Ang manufacturer ng device na ito ay nililimitahan ang iyong kakayahang kontrolin ang device mula sa aming app. Maaari kang gumawa ng mga pagbabago nang manu-mano o mula sa inirerekomendang app ng manufacturer.',
  deviceManufacturer: 'Manufacturer ng Device',
  deviceMode: 'Mode',
  deviceName: 'Pangalan ng Device',
  deviceOffline: 'Offline ang Device',
  deviceOptOutCopy: 'May naka-schedule na { duration } event sa { date } sa { time }. Alisin ang check sa mga kahon sa tabi ng mga device na ayaw mong lumahok sa event na ito.',
  deviceOptOutHead: 'Mga Device na Lumalahok',
  deviceOptOutModal: 'Pagkatapos mag-submit, maa-update ang iyong opt-out preferences. Maaaring tumagal ng hanggang 90 segundo upang makumpleto ang proseso.',
  deviceOverCopy: 'Maaari ka pa ring lumahok sa mga susunod na demand response event. Alamin pa kung paano ito nakakatulong sa pagtitipid ng enerhiya at pagpapatakbo ng electric grid sa pamamagitan ng pagbisita sa { supportEmail }.',
  deviceOverHead: 'Tapos na ang Event na Ito',
  devicePower: 'Power',
  devicePowerLimit: 'Limitasyon ng Power',
  deviceReconnect: 'I-reconnect ang iyong device upang makita ang mga opsyon sa kontrol.',
  deviceRoomAC: 'Room Air Conditioner | {n} Room Air Conditioner',
  deviceSensibo: 'Mini-Split o Window AC',
  deviceSettings: 'Mga Setting ng Device',
  deviceStatus: 'Status ng Device',
  deviceThermostat: 'Termostat | {n} Termostat',
  deviceTOU: 'Device TOU',
  deviceTstatSetpoint: 'Setpoint',
  deviceTstatTemp: 'Aktwal na Temperatura',
  deviceType: 'Uri ng Device',
  deviceUid: 'ID Number',
  deviceUnknown: 'Hindi Alam',
  deviceUnreachable: 'Hindi Maabot ang Device',
  deviceWaterHeater: 'Pampainit ng Tubig | {n} Pampainit ng Tubig',
  directMessage: 'Direktang Mensahe',
  directMessageTooltip: 'Pakitandaan na ang Direktang Mensahe ay gagamitin para sa suporta at pagbibigay ng mahalagang impormasyon tungkol sa iyong device. Hinihikayat naming huwag mag-unsubscribe sa mga mensaheng ito.',
  disableGrid: 'I-disable ang Grid',
  dispatchCurrent: 'Dispatch ayon sa Kasalukuyan',
  dispatchPower: 'Dispatch ayon sa Power',
  dispatchPV: 'Dispatch ayon sa PV',
  dispatchSiteDemand: 'Dispatch ayon sa Site Demand',
  drEventHead: 'Hi {name}, ngayon ay demand response day!',
  drEventMessage: 'May event ngayon na makakaapekto sa mga sumusunod na device. Huwag mag-alala, wala kang kailangang gawin. Mag-relax lang at tumulong sa pagpapanatili ng mababang rates. Maaari kang mag-opt out, ngunit maaaring hindi mo makuha ang ilang benepisyo!',
  dry: 'Tuyo',
  eco: 'Eco',
  efficiency: 'Episyente',
  electric: 'Elektriko',
  email: 'Email',
  emailAddress: 'Email Address',
  emailDisclaimer: 'Dahil ginagamit ang iyong email address sa proseso ng pag-login, kailangan naming i-validate ang anumang pagbabago. Para simulan ang proseso ng pagbabago, mangyaring makipag-ugnayan sa',
  emailHelp: 'Para sa tulong, makipag-ugnayan sa { supportEmail }.',
  emailPlaceholder: 'Ilagay ang iyong email address',
  enabled: 'Enabled',
  endTime: 'Hanggang {event end time}',
  energy: 'Enerhiya',
  energyBattery: 'NET ENERGY PARA SA BATERYA',
  energyConsumption: 'Konsumo ng Enerhiya',
  energyEvse: 'TOTAL NA ENERHIYA NA GINAMIT SA EV CHARGING',
  energyHwH: 'TOTAL NA ENERHIYA NA GINAMIT NG PAMPALIGO NG TUBIG',
  energySaver: 'Energy Saver',
  energyUsage: 'Paggamit ng Enerhiya',
  enterPhoneVerificationCode: 'Ilagay ang verification code para sa {phoneNumber}',
  enterPIN: 'Ilagay ang PIN',
  equipmentStatus: 'Status ng Kagamitan',
  error: 'Error',
  error404: 'Hindi natagpuan ang pahina. (Error 404)',
  errorGenericHead: 'Nagkaroon ng Error',
  errorGenericText: 'Ang sumusunod na error ay naranasan: {error}. Ang mga sumusunod na aksyon ay isinagawa: {actions}',
  errorInactive: 'Hindi Aktibo ang Account',
  errorNotFound: 'Hindi Natagpuan',
  ev: 'EV',
  evAwayPower: 'Away Power',
  evBatteryCapacity: 'Kapasidad ng Baterya ng EV',
  evBatteryLevel: 'Antas ng Baterya ng EV',
  evBatteryRange: 'Saklaw ng Baterya ng EV',
  evChargerHistory: 'Kasaysayan ng EV Charger',
  evChargingStatus: 'Status ng Pagcha-charge',
  evDeviceMfg: 'Manufacturer',
  evDeviceName: 'Pangalan',
  evDeviceSettings: 'Mga Setting ng EV',
  evDeviceStatus: 'Status ng EV',
  evDeviceChargeStatus: 'Status ng Charge ng EV',
  evDeviceLocation: 'Lokasyon ng EV',
  evHomePower: 'Power sa Bahay',
  evLocationStatus: 'Matatagpuan sa Bahay',
  evPluggedInStatus: 'Nakasaksak ang Charger',
  evRemainingRange: 'Natitirang Saklaw ng EV',
  evRemainingRangeFooter: '{evRangeUnit} ang maaaring marating ng sasakyan',
  evStateOfCharge: 'Estado ng Charge ng EV',
  evUpdateDevice: 'I-update ang Sasakyan',
  evVehicleModel: 'Modelo ng Sasakyan',
  evVehicleYear: 'Taon ng Modelo',
  eventCalendarEmpty: 'Inaabangan ang Iyong Unang Event!',
  eventCalendarResults: 'Mga Resulta ng Event Day',
  eventDevices: 'Lahat ng Device',
  eventDuration: 'Tagal ng Kaganapan:',
  eventEnergy: 'Kabuuang Enerhiya na Ginamit sa Kaganapan',
  eventEnergyBattery: 'ENERHIYA NA IBINIGAY NG BATERYA SA KAGANAPAN',
  eventEnergyEvse: 'ENERHIYA NA GINAMIT SA EV CHARGING SA KAGANAPAN',
  eventEnergyHwh: 'ENERHIYA NA GINAMIT NG PAMPALIGO NG TUBIG SA KAGANAPAN',
  eventEnergySavings: 'Enerhiya na Natipid sa Kaganapan',
  eventHead: 'Energy Management Kaganapan na Isinasagawa',
  eventOptout: 'Mag-opt out sa kaganapan',
  eventOptOut: 'Mga Opt-Out',
  eventParticipation: 'Partisipasyon',
  eventRuntimeTstat: 'RUNTIME SA KAGANAPAN',
  events: 'Mga Kaganapan',
  eventsResults: 'Sa {total} kaganapan na tinawag',
  eventsSuccess: 'MATAGUMPAY NA MGA KAGANAPAN',
  eventStartTime: 'Oras ng Pagsisimula ng Kaganapan:',
  eventText: 'Ang pagbabago ng mga kontrol o pag-opt out sa kaganapan na ito ay maaaring magdulot ng pagkawala ng savings!',
  eventToastActiveBody: 'ngayon ay demand response day. Ang Demand Response Day ay nangangahulugang kokontrolin namin ang iyong device mula',
  eventToastActiveTitle: 'May kaganapan ka ngayon!',
  eventToastOptout: 'Maaari kang mag-opt out sa kaganapan na ito sa pamamagitan ng <a href="#event-optout">pag-click dito</a>.',
  eventToastOptoutPartial: 'Pamahalaan ang paglahok ng iyong <strong>Tesla</strong> battery nang direkta sa Tesla app hanggang 3 oras bago o habang isinasagawa ang event. Para mag-opt out gamit ang ibang device, <strong><a href="#event-optout">i-click dito</a></strong>.',
  eventToastOptoutIneligible: 'Pamahalaan ang paglahok ng iyong <strong>Tesla</strong> battery nang direkta sa Tesla app hanggang 3 oras bago o habang isinasagawa ang event.',
  eventToastUpcomingBody: 'may naka-schedule na kaganapan para sa iyong device. Kokontrolin namin ang iyong device sa',
  eventToastUpcomingTitle: 'May naka-schedule kang kaganapan!',
  eventUnresponsive: 'Kasama ang mga hindi tumutugon na device',
  expiredLink: 'Mukhang sinubukan mong mag-login gamit ang expired na link. I-submit muli ang iyong email address upang makakuha ng bagong link.',
  extension: 'Extension',
  failedToOptoutOfEvent: 'Nabigong mag-opt out sa kaganapan.',
  fan: 'Fan',
  fanOnly: 'Fan Lang',
  favoriteMessage: 'Paboritong Mensahe',
  favorites: 'Mga Paborito',
  firstName: 'Unang Pangalan',
  forecastDay: 'ARAW',
  forecastEvening: 'GABI',
  forecastToday: 'Ngayon',
  from: 'Mula sa',
  fullyCharged: 'Lubos na Na-charge',
  generalNotification: 'Pangkalahatang anunsyo at notification',
  getStarted: 'Pumili ng mensahe upang magsimula.',
  gridTie: 'Grid Tie',
  heat: 'Init',
  heating: 'Pag-init',
  heatingSetpoint: 'Setpoint ng Pag-init',
  heatPump: 'Heat Pump',
  high: 'Mataas',
  highDemand: 'Mataas na Demand',
  holding: 'Hinahawakan',
  holdSetpoint: 'Hold Setpoint',
  homeownerSignIn: 'Pag-sign In ng May-ari ng Bahay',
  hour: 'oras',
  housePower: 'Power ng Bahay',
  hwhDefaultHead: 'Ilagay ang mga detalye ng iyong pampainit ng tubig:',
  hwhDefaultMode: 'Default na Mode ng pampainit ng tubig',
  hwhDefaultSetpoint: 'Default na Setpoint ng pampainit ng tubig',
  hybrid: 'Hybrid',
  idNumber: 'ID Number',
  inactiveMessage: 'Hindi aktibo ang iyong account. Mangyaring makipag-ugnayan sa support kung sa tingin mo ay may mali.',
  inbox: 'Inbox',
  incentiveMessage: 'Mga Mensahe ng Insentibo',
  incentiveMessageSecondaryText: '(kung naaangkop)',
  incentiveMessageTooltip: 'Hindi maaaring alisin ang mga insentibo email.',
  intelligence: 'Talino',
  lastName: 'Apelyido',
  latestActivity: 'Pinakabagong Aktibidad',
  leaderboard: 'Leaderboard',
  learning: 'Pagkatuto',
  learningMessage: '{deviceId} ay patuloy pang natututo',
  learningMode: 'Maaaring tumagal ng ilang linggo upang matutunan ang pinakamahusay na paraan ng pagtitipid. Gamitin ang iyong device nang normal at kami na ang bahala.',
  learningModeHead: 'Ang iyong device ay nasa learning mode',
  limitDispatch: 'Limitahan ang Dispatch',
  linkError: 'Error sa Pagpapadala ng Link',
  loaded: 'Loaded',
  loadEvents: 'Mag-load pa',
  loading: 'Naglo-load...',
  loadingMessage: 'Pinapabuti ang IQ ng Smart Grid…',
  loadingMessage2: 'Pinapababa ang carbon output gamit ang compute capacity.',
  loadshifting: 'DR Loadshifting',
  lockedOut: 'Na-lock out ka dahil sa sobrang maling pagtatangka. Maaari kang mag-try muli sa loob ng 15 minuto.',
  loginError: 'Error sa Pag-login',
  loginErrorWithContact: 'Nagkaroon ng error sa pag-login. Kung kailangan mo ng tulong, makipag-ugnayan sa {supportEmail}.',
  loginFailure: 'Nabigo ang iyong pagtatangka sa pag-login.',
  logout: 'Logout',
  low: 'Mababa',
  magicLinkError: 'Nagkaroon ng error sa pagpapadala ng Magic Link. Pakilagay ang iyong email sa susunod na pahina.',
  magicLinkMessage: 'Ang magic link ay dapat dumating sa iyong email inbox sa ilang sandali. Maaari mo nang isara ang browser window na ito.',
  manual: 'Manual',
  manufacturer: 'Manufacturer',
  maxCapacity: 'Pinakamataas na Kapasidad',
  maxTemperature: 'Pinakamataas na Temperatura',
  maxTempDisclaimer: 'Karamihan sa mga pampainit ng tubig ay maaaring itakda sa maximum na 140F, ngunit kung may thermostatic mixing valve, maaaring umabot ng 160F o higit pa.',
  medium: 'Medium',
  message: 'Mensahe',
  messageCenter: 'Sentro ng Mensahe',
  messageCenterWelcome: 'Maligayang pagdating sa iyong sentro ng mensahe!',
  messageInstructions: 'I-type ang mensahe dito',
  minTempDisclaimer: 'Ito ang pinakamababang temperatura na maaaring itakda ng iyong pampainit ng tubig sa panahon ng optimization events. Kung sa tingin mo ay masyadong mababa ang temperatura ng mainit na tubig, itaas ang bilang.',
  minTemperature: 'Pinakamababang Temperatura',
  mixingValve: 'balbula ng paghahalo',
  mixingValveDisclaimer: 'Ang device na ito ay may balbula ng paghahalo, at kinukumpirma kong nauunawaan ko ang mga safety considerations na nakasaad sa Terms and Conditions ng utility ko.',
  mixingValveWarning: 'Babala sa Balbula ng Paghahalo',
  mode: 'Mode',
  months: {
    january: {
      long: 'Enero',
      short: 'Ene',
    },
    february: {
      long: 'Pebrero',
      short: 'Peb',
    },
    march: {
      long: 'Marso',
      short: 'Mar',
    },
    april: {
      long: 'Abril',
      short: 'Abr',
    },
    may: {
      long: 'Mayo',
      short: 'May',
    },
    june: {
      long: 'Hunyo',
      short: 'Hun',
    },
    july: {
      long: 'Hulyo',
      short: 'Hul',
    },
    august: {
      long: 'Agosto',
      short: 'Ago',
    },
    september: {
      long: 'Setyembre',
      short: 'Set',
    },
    october: {
      long: 'Oktubre',
      short: 'Okt',
    },
    november: {
      long: 'Nobyembre',
      short: 'Nob',
    },
    december: {
      long: 'Disyembre',
      short: 'Dis',
    },
  },
  monthlyResults: 'Ang Iyong Resulta ng {month}',
  newPassword: 'Bagong Password',
  newPasswordConfirm: 'Kumpirmahin ang Bagong Password',
  newPasswordInstructions: 'Mangyaring maglagay ng bagong password. Dapat ay 12 karakter o higit pa at may kasamang: Isang uppercase letter, isang lowercase letter, at isang numero.',
  newPasswordPlaceholder: 'Ilagay ang Bagong Password',
  newSchedule: 'Magdagdag ng Bagong Schedule',
  nickname: 'Palayaw',
  noDevicesToOptout: 'Walang device na pwedeng mag-optout.',
  none: 'Wala',
  noSubject: 'Walang Subject',
  notCharging: 'Hindi Nagcha-charge',
  notificationPreferences: 'Mga Kagustuhan sa Notification',
  notifications: 'Mga Notification',
  notify: 'I-notify ako…',
  oauthSuccess: 'Tagumpay!',
  oauthSuccessCopy: 'Salamat sa pag-enroll ng iyong device',
  off: 'OFF',
  offline: 'Offline',
  offlineDeviceNotification: 'Kung may isa sa aking device na mag-offline',
  offset: 'Offset',
  oldPassword: 'Lumang Password',
  oldPasswordPlaceholder: 'Ilagay ang Lumang Password.',
  on: 'ON',
  online: 'Online',
  optedOut: 'Na-opt out na',
  optimizationBody: 'Dahil binago mo ang mode ng iyong device sa {vacationSetting}, na-disable ang Time of Use Optimization. Para i-enable muli, i-update ang Mode.',
  optimizationHead: 'Na-disable ang Optimization',
  optoutWithApp: 'Mag-opt out gamit ang native app',
  outOfHome: 'Wala sa Bahay',
  overallStandings: 'Kabuuang Rankings',
  participants: 'Mga Kalahok sa Program',
  password: 'Password',
  passwordErrorEmail: 'Hindi pwedeng kapareho ng email address ang password.',
  passwordErrorMismatch: 'Hindi tugma ang lumang password. Pakisubukang muli.',
  passwordErrorName: 'Hindi pwedeng kapareho ng pangalan ang password.',
  passwordErrorRequirements: 'Dapat matugunan ng password ang mga kinakailangan sa itaas. Pakisubukang muli.',
  passwordHeader: 'Gamitin ang Password',
  passwordInstructions: 'Kung ito ang unang beses mong mag-login, gamitin ang Secure Link login',
  passwordPlaceholder: 'Ilagay ang iyong password',
  passwordReset: 'I-RESET ANG PASSWORD',
  passwordResetLink: 'Nakalimutan ang password?',
  passwordResetMessage: 'Ilagay ang iyong email address at padadalhan ka namin ng link para i-reset ang iyong password. Para sa karagdagang tulong, mag-email sa {supportEmail}.',
  passwordSignIn: 'Mag-sign in gamit ang password',
  passwordSuccess: 'Matagumpay na na-update ang password.',
  peakDemandNotification: 'Bago ang peak demand events',
  peakShaving: 'Peak Shaving',
  percent: 'Porsyento',
  percentCharged: 'Porsyento ng Charge',
  performance: 'Performance',
  phoneError: 'Nagkaroon ng error. Pakilagay muli ang numero ng telepono.',
  phoneErrorDuplicate: 'Duplicate na numero ng telepono. Babalik sa listahan ng numero.',
  phoneInstructions: 'Ilagay ang iyong numero ng telepono at padadalhan ka namin ng verification code. Kapag na-verify, makakatanggap ka ng SMS alerts tungkol sa iyong account at device.',
  phoneNumber: 'Numero ng Telepono',
  phoneNumbers: 'Mga Numero ng Telepono',
  phoneOptOut: 'Nag-opt out ka sa pagtanggap ng SMS. Para mag-opt in, makipag-ugnayan sa {supportEmail}.',
  phonePlaceholder: {
    america: 'Halimbawa: (555) 555-5555',
    australia: 'Halimbawa: 0555 555 555',
  },
  phoneToolTip: 'Para makatanggap ng text message, kailangan ng numero ng telepono. I-click ang link sa itaas.',
  phoneVerifyHead: 'I-verify ang Numero ng Telepono',
  phoneVerifyIntro: 'Ang pag-verify ng numero ng telepono ay nagbibigay-daan sa amin na magpadala ng mahalagang impormasyon tungkol sa mga event, performance, at insentibo. I-verify ang numerong ibinigay mo sa enrollment.',
  phoneVerifyTooltip: 'Ang numerong ito ay inilagay sa enrollment. Maaaring magdagdag ng karagdagang numero sa Account Profile page.',
  power: 'Power',
  precipitation: 'Pag-ulan',
  preferenceInstructions: 'Piliin kung paano mo gustong makipag-ugnayan.',
  preferences: 'Mga Kagustuhan',
  presentCapacity: 'Kasalukuyang Kapasidad',
  priorityBackup: 'Priority Backup',
  profile: 'Profile',
  programImpact: 'Epekto ng Program',
  providerWelcome: 'Maligayang pagdating sa {providerName}',
  pvPower: 'PV Power',
  pvSmoothing: 'PV Smoothing',
  pvSmoothingRate: 'PV Smoothing Rate',
  ratePercent: 'Rate (%)',
  relative: 'Relatibo',
  remoteArbitrage: 'Remote Arbitrage',
  reply: 'SAGOT',
  resendCode: 'Ipadala muli ang code',
  resetPassword: 'I-reset ang Password',
  reviseButton: 'BAGUHIN',
  right: 'kanan',
  run: 'Patakbuhin',
  runtime: 'Runtime (s)',
  runtimeTstat: 'KABUUANG RUNTIME',
  safetyShutdown: 'Safety Shutdown',
  save: 'I-save',
  saved: 'Na-save',
  saving: 'Nagse-save',
  schedule: 'Schedule',
  scheduleDays: 'Mga Araw ng Schedule',
  scheduleDeviceMode: 'Mode ng Device',
  scheduleError: 'Hindi sapat ang impormasyon ng schedule na ito upang tumakbo.',
  scheduleHeader: 'Mga Schedule',
  scheduleName: 'Pangalan ng Schedule',
  scheduleSetpoint: 'Setting ng Temperatura',
  scheduleStartTime: 'Oras ng Pagsisimula',
  scheduleTabTitle: 'Schedule ng Device',
  search: 'Maghanap ng Mensahe',
  secureLinkHeader: 'Gamitin ang Secure Link',
  secureLinkSignIn: 'Mag-sign in gamit ang espesyal na link na ipinadala sa email address sa ibaba.',
  security: 'Seguridad',
  selectHWH: 'Aling pampainit ng tubig(s) ang gusto mong patakbuhin sa schedule na ito?',
  selfSupply: 'Sariling Supply',
  sell: 'Ibenta',
  send: 'Ipadala',
  sendCode: 'Ipadala ang Code',
  sending: 'Nagpapadala...',
  sendPIN: 'Ipadala sa akin ang PIN',
  sendSecureLink: 'Ipadala ang Secure Link',
  sent: 'Naipadala',
  setFavorite: 'Itakda bilang paboritong mensahe',
  setPassword: 'Itakda ang Password',
  setpoint: 'Setpoint',
  setpointControl: 'Kontrol ng Setpoint',
  setTemp: 'Itakda ang Temperatura',
  setTemperature: 'Itakda ang Temperatura',
  settings: 'Mga Setting',
  setUpProfile: 'I-set up ang Profile',
  signIn: 'Mag-sign In',
  simulatedPV: 'Awtomatikong Simulated PV',
  sleep: 'Tulog',
  sms: 'SMS',
  standard: 'Standard',
  standby: 'Standby',
  status: 'Status',
  subject: 'Subject',
  submitButton: 'Isumite',
  successfulOptout: 'Matagumpay na Optout',
  switchDevice: 'Palitan ang Device',
  tankTemp: 'Temperatura ng Tank',
  tankTemperature: 'Temperatura ng Tank',
  temperature: 'Temperatura',
  time: 'Oras',
  to: 'Sa',
  totalEnergy: 'Kabuuang Enerhiya na Natipid',
  totalOptouts: 'KABUUANG EVENT OPT-OUTS',
  totalParticipation: 'Kabuuang Partisipasyon',
  tryAgain: 'Subukang Muli',
  twoFactorAuth: 'Dalawang Factor na Authentication',
  twoFactorInstructions: 'I-verify ang iyong pagkakakilanlan sa pamamagitan ng paglalagay ng 6 digit code mula sa authenticator app sa iyong device.',
  unableToSend: 'Hindi maipadala ang Code',
  unit: 'Yunit',
  unknown: 'Hindi Alam',
  unreachable: 'Hindi Maabot',
  unsetFavorite: 'Tanggalin bilang paborito',
  until: 'hanggang',
  unverified: 'Hindi Na-verify',
  updated: 'na-update',
  updateDevice: 'I-update ang Device',
  updateProfile: 'I-update ang Profile',
  userDefined: 'Tinukoy ng User',
  userParticipation: 'Ang Iyong Partisipasyon sa Event',
  userResults: 'xx ng xx',
  userStandings: 'Ang Iyong Rankings',
  vacation: 'Bakasyon',
  vehicleData: 'Data ng Sasakyan',
  vehicleDetails: 'Detalye ng Sasakyan',
  verificationCode: 'Verification Code',
  verified: 'Na-verify',
  verifiedToast: {
    title: 'Matagumpay mong na-verify ang Numero ng Telepono!',
    body: 'Na-verify na ang numero ng telepono at gagamitin para sa mahalagang impormasyon mula sa Utility. Maaaring magdagdag ng karagdagang numero sa Account Profile.',
  },
  verifyFailToast: {
    title: 'Maling Verification Code!',
    body: 'Mali ang Verification Code na inilagay mo. Maaari mong subukang ilagay muli ang Verification Code sa ibaba o magpadala ng bagong code sa iyong telepono sa pamamagitan ng pag-click sa "Resend Code" button sa ibaba.',
  },
  verifyNumber: 'I-verify',
  voice: 'Boses',
  voltVar: 'Volt/Var Control',
  warning: 'Babala',
  watts: 'Watts',
  weatherConditions: 'Kasalukuyang Kondisyon ng Panahon',
  weatherForecast: 'Taya ng Panahon',
  welcome: 'Maligayang Pagdating sa Bahay',
  welcomeMessage: 'Masaya kaming nandito ka. Maaari kang magsimulang magtipid ng enerhiya (at pera!) bawat buwan sa pamamagitan ng pagkonekta ng mga smart device ng iyong bahay.',
  welcomeModalDefaultBody: 'Maligayang pagdating sa {providerName}\'s {programNames} Homeowner\'s App! Pinapayagan ka ng Homeowner\'s App na subaybayan ang lahat ng nakakonektang mga device sa {providerName}\'s {programNames} Program{programNames.length > 1 ? \'s\' : \'\'}. Upang magsimula, i-click ang "I-setup ang Profile" na button sa ibaba.',
  welcomeModalTitle: 'Maligayang pagdating sa {providerName}\'s Homeowner App',
  welcomeModalSetupProfile: 'I-setup ang Profile',
  wind: 'hangin',
  writeReply: 'Sumulat ng Sagot',
  wrongContactInfo: 'Kung hindi ito ang iyong contact information, huwag pansinin ang pahinang ito dahil maaaring naipasa lang sa iyo ang mensahe.',
  yourDevicesHaveBeenOptedOut: 'Na-opt out na ang iyong mga device sa event',
  yourDevicesHaveBeenOptedOutAlt: 'Na-opt out na sa event ang iyong mga kwalipikadong device. Pamahalaan ang paglahok ng iyong <strong>Tesla</strong> battery nang direkta sa Tesla app hanggang 3 oras bago o habang isinasagawa ang event.',
};
